export default "__VITE_ASSET__D_vXCtRJ__"